import { useRef } from "react";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import { Map } from "../../icons/Map";
import { useSelector, shallowEqual } from "react-redux";
import classNames from "classnames";
import { useResizeObserver } from "app/hooks";
import "./MapButton.scss";

const ONE_LINE_FILTER_BUTTON_HEIGHT = 50;

const MapButtonBase = ({ googleAPIKey, onClick, isLoading = false }) => {
	const buttonRef = useRef(null);
	const { height: buttonHeight } = useResizeObserver({ ref: buttonRef });

	const isButtonTall = buttonHeight >= ONE_LINE_FILTER_BUTTON_HEIGHT;

	if (isLoading) {
		return (
			<div className="map-button__loader">
				<LoaderBar height={12} width={60} />
			</div>
		);
	}

	if (!googleAPIKey) {
		return null;
	}

	return (
		<button
			type="button"
			className={classNames("map-button", {
				"map-button--tall": isButtonTall,
			})}
			onClick={onClick}
			disabled={isLoading}
			ref={buttonRef}
			data-testid="map-button"
		>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.LARGE}
				isBold
				component="span"
				className={classNames("map-button__label", {
					"map-button__label--tall": isButtonTall,
				})}
			>
				<Map className="map-button__icon" />
				<FormattedMessage id="product.page.map.button.label.long" />
			</Typography>
		</button>
	);
};

MapButtonBase.propTypes = {
	googleAPIKey: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
};

const mapStateToProps = state => ({
	googleAPIKey: state.envVars.GOOGLE_API_KEY,
});

export const MapButton = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <MapButtonBase {...props} {...stateProps} />;
};
